/* ==========================================================================
   SearcherFerryHotelRxjs > Templates > vehicle
   ========================================================================== */

/* Import modules */
const { html } = require('common-tags');

const { addData, addStyle } = require('@bluekiri/alexandria/helpers/dataHelpers');

const SelectTemplate = require('@bluekiri/alexandria-contrib-components/components/select-rxjs/template');
const SelectConfig = require('@bluekiri/alexandria-contrib-components/components/select-rxjs/client/js/config');

const configuration = require('../client/js/config');

const renderVehicles = (data, context) => {
    if (!data.vehicles) return html('');

    const { vehicles, literals = {}, config = {} } = data;
    const { vehicleLabel = '' } = literals;

    const selectData = addStyle(
        addData(
            {
                config: {
                    ...config,
                    literals
                },
                items: vehicles.map(item => ({
                    value: item.value,
                    label: item.label,
                    selected: item.selected,
                    customProperties: {
                        height: item.height,
                        length: item.length,
                        trailer: item.trailer
                    }
                })),
                label: vehicleLabel
            },
            {
                type: configuration().type.vehicles
            }
        ),
        [SelectConfig().css.withBorder]
    );

    return SelectTemplate(selectData, context);
};

/**
 * PanelVehicleRxjs template
 * @param {object} data Object containing the data model for this component.
 * @param {object} context The general context object.
 * @returns {object} Additional data to have available in the template
 */
module.exports = function Template(data) {
    if (!data.vehicles) return html('');

    /* Data */
    const { literals = {}, vehicles, config = {} } = data;

    /* Template */
    return html(`
        <div class='vehicle-panel'>
            ${renderVehicles({ vehicles, literals, config })}
        </div>
    `);
};
